export const DashboardSummarySkeleton = () => {
  return (
    <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
      <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white p-4 rounded-lg space-y-3 animate-pulse"
          >
            <div className="h-4 w-1/2 bg-gray-300 rounded"></div>
            <div className="h-6 w-1/3 bg-gray-300 rounded"></div>
            <div className="h-3 w-2/3 bg-gray-300 rounded"></div>
          </div>
        ))}
      </div>
    </section>
  );
};
